export default __webpack_public_path__ + "static/PAPC_2022_OlybetSats-1d39a8e6d02c962b50d2a8448cc821c9.pdf";